import { action } from "satcheljs";

export interface TriggerOnDemandDecryptionActionMessage {
    itemId: string;
    conversationId: string;
}

const triggerOnDemandDecryption: (itemId: string, conversationId: string) => TriggerOnDemandDecryptionActionMessage = action("triggerOnDemandDecryption", (itemId: string, conversationId: string): TriggerOnDemandDecryptionActionMessage => ({
    itemId,
    conversationId,
}));

export default triggerOnDemandDecryption;
